import i18n from '@/locales/i18n';
import { message } from '@koi-design/uxd-ui';

const copyTextWithExecCommand = text => {
  if (typeof document === 'undefined' || !document.body) {
    throw new Error('Document is not available');
  }

  const textarea = document.createElement('textarea');
  const activeElement = document.activeElement;
  const selection = window.getSelection?.();
  const ranges = selection
    ? Array.from({ length: selection.rangeCount }, (_, index) =>
        selection.getRangeAt(index).cloneRange()
      )
    : [];

  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '-9999px';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);

  let copied = false;
  try {
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    copied = document.execCommand('copy');
  } finally {
    textarea.remove();
    if (selection) {
      selection.removeAllRanges();
      ranges.forEach(range => selection.addRange(range));
    }
    activeElement?.focus?.({ preventScroll: true });
  }

  if (!copied) {
    throw new Error('Copy command was rejected');
  }
};

export const copyText = (
  val,
  msg = i18n.global.t('message.514d83dcad963f805b0b6607f56596b1')
) => {
  const text = String(val ?? '');
  const clipboardWrite =
    typeof navigator !== 'undefined' &&
    typeof navigator.clipboard?.writeText === 'function'
      ? Promise.resolve().then(() => navigator.clipboard.writeText(text))
      : Promise.reject(new Error('Clipboard API is unavailable'));

  return clipboardWrite
    .catch(() => copyTextWithExecCommand(text))
    .then(() => {
      message.success(msg);
    })
    .catch(err => {
      message.error(err.toString());
    });
};
